import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';

export default {
  getLogsUser({ commit }, data) {
    commit('setLoading', true);
    const { filters, pagination } = data;
    const {
      date_range,
      module,
      what_has_changed,
      action,
      status,
      identity_change,
      author_email,
    } = filters;
    const { start: start_period, end: end_period } = date_range;
    return GraphQlClient.query(`
    query(
      $start_period: String!
      $end_period: String!
      $module: String
      $what_has_changed: String
      $action: String
      $status: String
      $identity_change: String
      $author_email: String
      $pagination: LogsUserPagination
    ){
      getLogsUser(
        start_period: $start_period
        end_period: $end_period
        module: $module
        what_has_changed: $what_has_changed
        action: $action
        status: $status
        identity_change: $identity_change
        author_email: $author_email
        pagination: $pagination
      ) {
        total_items
        page_items {
          id
          client_id
          action_time
          author_email
          action
          module
          status
          what_has_changed
          identity_change
          payload_before
          payload_after
          error_message
        }
      }
    }
    `, {
      start_period,
      end_period,
      module,
      what_has_changed,
      action,
      status,
      identity_change,
      author_email,
      pagination,
    }).then(({ data: dataLogsUser }) => {
      const { getLogsUser } = dataLogsUser;
      const { page_items, total_items } = getLogsUser;
      commit('setLogsUser', page_items || []);
      commit('setTotalLogsUser', total_items || 0);
      commit('setLoading', false);
      return Promise.resolve(dataLogsUser);
    })
    .catch((err) => {
      commit('setLogsUser', []);
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  exportLogsUser({ commit }, data) {
    commit('setExportLoading', true);
    const { filters } = data;
    const {
      date_range,
      module,
      what_has_changed,
      action,
      status,
      identity_change,
      author_email,
    } = filters;
    const { start: start_period, end: end_period } = date_range;
    return GraphQlClient.query(`
    query(
      $start_period: String!
      $end_period: String!
      $module: String
      $what_has_changed: String
      $action: String
      $status: String
      $identity_change: String
      $author_email: String
    ){
      exportLogsUser(
        start_period: $start_period
        end_period: $end_period
        module: $module
        what_has_changed: $what_has_changed
        action: $action
        status: $status
        identity_change: $identity_change
        author_email: $author_email
      ) {
        file_name
        file_data
      }
    }
    `, {
      start_period,
      end_period,
      module,
      what_has_changed,
      action,
      status,
      identity_change,
      author_email,
    }).then(({ data: dataLogsUser }) => {
      const { exportLogsUser } = dataLogsUser;
      const { file_name, file_data } = exportLogsUser;
      const tempDownloadLink = document.createElement('a');
      const blob = new Blob([file_data], { type: 'text/csv' });
      tempDownloadLink.href = window.URL.createObjectURL(blob);
      tempDownloadLink.download = file_name;
      tempDownloadLink.click();
      commit('setExportLoading', false);
      return Promise.resolve(dataLogsUser);
    })
    .catch((err) => {
      commit('setExportLoading', false);
      return Promise.reject(err);
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/user/store/actions.js